import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper";
import { Pagination } from "swiper/modules";

export default class MyCarouselController extends Controller {
  initialize() {
    this.swiperClass = this.data.get("swiperClass");
    this.paginationClass = this.data.get("paginationClass");
  }

  connect() {
    if (this.swiperClass && this.paginationClass) {
      this.swiperInit(this.swiperClass, this.paginationClass);
    }
  }

  swiperInit(swiperClass, paginationClass) {
    // to customize the sizing for packages carousel in profile page
    const profilePackages = swiperClass == "profilePackagesSwiper";

    this.swiper = new Swiper(`.${swiperClass}`, {
      modules: [Pagination],
      autoplay: { pauseOnMouseEnter: true },
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: `.${paginationClass}`,
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: profilePackages ? 1 : 2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: profilePackages ? 2 : 3,
          spaceBetween: 15,
        },
        992: {
          slidesPerView: profilePackages ? 3 : 4,
          spaceBetween: 20,
        },
      },
    });
  }
}
